import { UserNotification } from "../@types/user";

export const hasNotification = (notifications: UserNotification[]) =>
  notifications.some(
    (notification: UserNotification) => notification.read === false
  );

export const orderNotifications = (notifications: UserNotification[]) => {
  return notifications.sort((a, b) => {
    // Sort by read status first: unread (false) should come before read (true)
    if (a.read === b.read) {
      // If both have the same read status, sort by creation time descending (newest first)
      return b.createdAt.seconds - a.createdAt.seconds;
    }
    return a.read ? 1 : -1;
  });
};

export const unreadNotificationLength = (notifications: UserNotification[]) => {
  return notifications.filter((notification) => !notification.read).length;
};
